"use strict";

var _taggedTemplateLiteral = require("/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: auto;\n  max-width: ", "px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var grid_1 = require("../grid");

exports.Wrapper = styled_components_1.default.div(_templateObject(), grid_1.grid.breakpoints.lg);